
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Ceci est apporté par <a href="${0}"> projet Folksonomy Engine </a> N’hésitez                     pas à participer ou à donner votre avis`,
'h5d824b4954e56ea5': html`Scannez vos <span class="everyday">aliments quotidiens</span> <span class="foods"></span>`,
'h6bdd1b427aa985a4': html`Cet outil vous permet de corriger la liste des ingrédients. Vous pouvez ajouter, supprimer ou modifier
                la liste des ingrédients.
                <br>
                Ce caractère <span class="highlight">␣</span> représente un espace.
                <br>
                Ce caractère <span class="highlight">↩︎</span> représente un saut de ligne. `,
'hb28f1f2ec1744ee9': html`Ces propriétés sont créées et ajoutées par les utilisateurs pour tout type d’utilisation. N’hésitez pas à
                    ajouter les vôtres. Les propriétés et valeurs que vous créez
                    <strong>doivent être factuel</strong>. Vous pouvez approfondir dans
                    <a href="${0}">la liste des propriétés déjà utilisées par la communauté</a>
                    ou explorer la
                    <a href="${1}">documentation des propriétés et son moteur de recherche</a>.`,
's000a5b76bd3a01c2': `Chargement des propriétés...`,
's000d98595e959c1e': `Disponible sur Google Play`,
's013bdc8cf0d3583d': `Aidez-nous pour les ingrédients`,
's01d2865e3e1d5501': `Merci pour votre aide !`,
's02ce7a2e7c1b020b': `Valider le recadrage`,
's03e9c8114521b998': `Je vais éditer les ingrédients`,
's05ec315d9308091a': `Icône de coins de code-barres`,
's061eb5af92512c85': `Sauvé ! Pouvez-vous m'aider pour un autre ?`,
's06847c221c4c0bc1': `Je voudrais créer une propriété pour [décrivez votre cas d'utilisation]...`,
's06f6c6f99db6b552': `Original`,
's081e2ad82db71e1d': `Valeurs groupées`,
's09205907b5b56cda': `Non`,
's0b4235aae602a950': `documentation dédiée`,
's0bb2d48532acc455': `Télécharger CSV`,
's0d5b7fee0311db68': `Propriété`,
's0fb218abc2e157ed': `Invalider l'image`,
's100c4928cc74642a': `soutenir l’avancement de la recherche en santé publique.`,
's10db5498186c083b': `Annuler le recadrage`,
's11a18a69b30b65ed': `Aidez-nous à corriger les erreurs dans la liste des ingrédients`,
's1205d5f6fccf8e69': `Valeur de la propriété`,
's15d64a0a6715285a': `Nouvelle clé`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Zone de sélection`,
's1a52515ec8ddade8': `Code-barres du produit`,
's1c5031113de500ce': `garder notre base de données ouverte &amp; disponible pour tous,`,
's1dc4daf989c71284': `Aidez-nous à corriger les informations nutritionnelles`,
's1e00019dc454872d': `Veuillez fournir un nom de propriété en utilisant l'attribut property-name.`,
's1e49126af0935a5b': `Liste des produits utilisant cette propriété`,
's21e73088de6f26f3': `Disponible sur l'App Store`,
's255857544a9d5ec0': `Réinitialiser`,
's25e94495991e95ba': `Merci pour votre aide ! Pouvez-vous répondre à une autre question ?`,
's2ceb11be2290bb1b': `Annuler`,
's2db7b654c0a9bde0': `Documenter la propriété`,
's300b3a6ee4e1252d': str`Mauvaise correspondance ${0}%`,
's33f786bb6b4f0cf4': `Résultat du recadrage`,
's33f85f24c0f5f008': `Enregistrer`,
's34be4af4e8fec4ae': `Demandez d'abord à la communauté`,
's36d86adc823cbfa6': `Avant de créer une nouvelle propriété, discutez-en avec la communauté :`,
's3781d25aa51a736c': `Documentation du moteur Folksonomie`,
's383ae4449428b61e': `Réinitialiser le recadrage`,
's39bcf88721a1e8ee': `Réinitialiser la sélection`,
's39e14e14300694c7': `Documentation et directives`,
's3b430cfa5c1fe7f4': str`Documentation pour ${0}`,
's3f4e4b52f230a892': `Toile d'image`,
's417b90913e05bc17': `Aperçu`,
's41f7dca46d3f1b4a': `Valeur`,
's422bba9636ce2489': `Image centrale`,
's42dd66b2441566fd': `Icône centrale`,
's43df2e8395f6834e': str`Veuillez faire un don à notre collecte de fonds ${0}`,
's453188ea728f64da': `Ajouter un nutriment`,
's453ab0dbb9b5c777': `Redimensionner à droite`,
's475b08749d0706ed': `Aidez-nous à informer des millions de consommateurs à travers le monde sur ce qu'ils mangent`,
's49730f3d5751a433': `Chargement ...`,
's4bbc7472834a9686': `Votre navigateur ne prend pas en charge la lecture de codes-barres.`,
's4d42cc7e00076a3b': `Nombre de produits`,
's4df2f533c0c1e7d0': `Contrôles d'image`,
's4e94adf723979402': `Open Food Facts a besoin de votre aide avec ce produit.`,
's4f4886341969d552': `Déplacer la sélection`,
's4f751fb9b3ed766c': `Créer une nouvelle propriété`,
's547c12ae169d00bc': `Disponible sur F-Droid`,
's5560fb119e40923d': `Entrez le nom de la propriété...`,
's55d7249883a98ca1': `à propos de cette propriété sur le wiki Open Food Facts`,
's565867d84c04aea2': `Propriétés du filtre...`,
's5666afe5cd0166de': `Veuillez corriger les erreurs ou modifier le texte avant de confirmer`,
's57472465a23b41db': `Valeurs`,
's58e1eeea7a60ae51': `Chargement des produits...`,
's59df20feee978e5b': `Erreur : valeur invalide.`,
's5c92c0051d44b6de': `Aidez-nous à corriger les informations nutritionnelles.`,
's5dd6f12783fca34f': `Modifier la liste des ingrédients`,
's5e8250fb85d64c23': `Fermer`,
's5ed03bb1f3a15949': `Image`,
's6306a31415aea913': `JE SOUTIENS`,
's6498dfe4855bb3a7': `unité`,
's64ef2a6c2dd1d3d1': `Modifier`,
's66413c24dcf680e2': `Ignorer`,
's67ae6594857a4d57': `Merci pour votre contribution !`,
's6cee7cad81dfedd1': `Image recadrée`,
's6d7b6cdedaadfb6e': `Chaque don compte ! Nous apprécions votre soutien pour une plus grande transparence alimentaire dans le monde.`,
's7124dde792a8faa2': `APK Android`,
's718dea04853f80ae': str`Bonne correspondance ${0}%`,
's71a5c9f4b68ef4d4': `Compter`,
's74cb3d66f6a668e1': `Documentation`,
's787dd11bed0dc88a': `Redimensionner à gauche`,
's7ce4fd9430e80cea': `valeur`,
's801a05fa8e881f37': `En savoir plus sur la création de propriétés et les directives :`,
's8038273de2cf8b73': `Veuillez sélectionner une région à recadrer.`,
's839cc2908a5387f2': `Filtrer les codes-barres...`,
's86197dcf3e96af64': `Parcourir et rechercher des propriétés existantes`,
's8a63be30a129a59c': `Redimensionner le bas`,
's8a8bfd67f2dd2810': `Téléchargez l'application OFF avec ce code QR`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Redimensionner en haut à droite`,
's8db84aa4bc949af2': `Documenter la nouvelle propriété`,
's8f839a03997a16d7': `Voir le produit`,
's901ae1e236ac45d3': `Annuler la suppression`,
's907f7a97c6b29425': `Attention, le modèle de données peut être modifié. Utilisez-le à vos risques et périls.`,
's95d23d03f9147581': `Dézoomer`,
's976dfd19ef58a1e1': `Cliquez pour scanner un code-barres et découvrir ses détails (santé, préférences, etc.)`,
's98ff35f2a00dc60d': `Ingrédients :`,
's9a7f60fce090ecaf': `Échec du chargement des propriétés. Veuillez réessayer ultérieurement.`,
's9b87abd68fb9df45': `Introuvable ? Créer une nouvelle clé {value}`,
's9c0f52425fd2f07e': `Peut ne pas correspondre`,
's9fc41f789c63b40d': `Produits`,
'sa1fa766e0d5634d7': `Aucune partition disponible`,
'sa548778b24054030': `Explorez toutes les propriétés issues du projet Folksonomy Engine. Ces propriétés fournissent des métadonnées et des informations supplémentaires sur les produits de la base de données Open Food Facts.`,
'sa63907958bd0ec4b': `Redimensionner en haut à gauche`,
'sa95b4224f685a36a': `Fermer la fenêtre modale`,
'sab56a1d439576fd6': `Icône de suggestion`,
'sac47ea2901d04c15': `Redimensionner en bas à gauche`,
'sb125227d436c2925': `Recherchez votre concept de propriété dans la base de données de propriétés existantes :`,
'sb125568d43642e6f': `Répondez aux questions sur le produit.`,
'sb1c538e038f9b214': str`Très bonne correspondance ${0}%`,
'sb28639570ff3b852': `liste de toutes les propriétés`,
'sb3bdd638a58d30f4': `mobiliser une communauté de citoyens engagés,`,
'sb3cbcc1bd0fff140': `Une fois que vous avez vérifié que votre propriété n'existe pas et que la communauté convient qu'elle est utile, vous devez d'abord la documenter dans le wiki.`,
'sb3d4f79d9d8b71e5': `Envoyer`,
'sb560fa37a7bfb6c2': `Aucun produit trouvé pour cette propriété.`,
'sb7f72e4c8a2d3357': `Filtrer les valeurs...`,
'sb8178320160f84ea': `Afficher la photo recadrée`,
'sbad7d2734149470b': `Valider`,
'sbb623d6b18d966a0': `Les informations nutritionnelles sont affichées sur l'emballage :`,
'sbd6be5cde472f37c': `Toutes mes questions ont été répondues ! Merci pour votre aide !`,
'sbd9a0b2293b3cd3c': `Taille d'une portion`,
'sbe472dc3c2685985': `Valeur correspondante`,
'sc0520e1732a5c568': `Agrandir l’image`,
'sc0cc559e7ede852a': `Redimensionner le haut`,
'sc1c08d0cbcc3bd24': `Ne correspond pas`,
'sc52696641af72b53': `Installer l'app!`,
'sc5575e3107f87874': `Faire pivoter l'image vers la gauche`,
'sc57b630a7a70c61f': `Solution suggérée`,
'sc681b137e8f604f7': `Confirmer la suppression`,
'sc6daf8a31883f8b9': `Déplacer l'image`,
'sc895972c88d38ca5': `Propriété folksonomique`,
'sca0c3305aff570b8': str`par portion spécifiée "${0}"`,
'scace072bef961918': `Lignes`,
'scb3b0671d7b7f640': `Nouvelle valeur`,
'scb489a1a173ac3f0': `Oui`,
'scbab4bd737ba7934': str`photo de groupe pour les dons ${0}`,
'scd21019c3cd618f3': `Rejoignez la discussion Slack`,
'scdb6cad0b92721bf': `Aucune propriété trouvée.`,
'scf23a05631f93732': `Confirmer la suppression`,
'scfed2f270ef6a3aa': `Sélectionnez la zone`,
'sd1022bc1ef9204f7': `Image zoomable`,
'sd1077c055cf9ba6b': `Aidez-nous à valider la liste des ingrédients du produit.`,
'sd698d21ddecba56b': `Bonjour ! Vous pouvez nous aider à améliorer les informations sur le produit en répondant aux questions suivantes :`,
'sd82bc2decefa621b': `rester indépendant de l'industrie alimentaire,`,
'sdb97e5976482606e': `Vérifier si une propriété existe déjà`,
'sdbf806fefc584115': `Vous devriez trouver un`,
'sdc673e73b5c13aea': `Supprimer`,
'sdc792b75f1edcaba': `Aidez-nous à corriger l'orthographe des ingrédients.`,
'sdca5deead576ceee': `Redimensionner en bas à droite`,
'sdcc2555c5dde524f': `Êtes-vous sûr de vouloir supprimer cet élément ? Cette action est irréversible.`,
'se206feec7ec57b28': `pour 100g`,
'se419a9ab36987490': `Invalider`,
'se5127cf0f92e7e48': `Astuce : vous pouvez également retrouver le`,
'se773f50d2a16d481': `Faire pivoter l'image vers la droite`,
'sebb2c6c830a44574': `infrastructure technique (site web/application mobile) &amp; une petite équipe permanente`,
'sec6377f3c4e9b28c': `Je propose un meilleur recadrage`,
'seea3800e27baa686': `Produits individuels`,
'sefaba4adc4ec9219': `Propriétés de la folksonomie`,
'seffa8ca49175b5f0': `Propriétés personnalisées`,
'sf44a6b3b232c28ea': str`Remplacer la valeur actuelle par ${0}`,
'sf4cd86a2f5ef2588': `Code-barres du produit`,
'sf57a61152168cc81': `Aidez-nous à corriger la détection des ingrédients`,
'sf88b90b8ba23871c': `Match inconnu`,
'sf9aee319a006c9b4': `Ajouter`,
'sfacbbe968fa7d773': `Nom de la propriété:`,
'sfc40ea3d5d5aa6f8': `Vos dons financent le fonctionnement quotidien de notre association à but non lucratif :`,
'sfe87465d50530725': `Valeur correspondante`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  